// permissions.js
const PERMISSIONS = {
  ADD_Order: 1, // اضافة طلبيات
  Orders_Report: 2, // تقرير الطلبيات
  Receiving_Orders: 3, // استلام طلبات
  Return_Item: 4, // ارجاع صنف في طلبية
  Return_Order: 5, // ارجاع طلبية
  Approve_Order: 6, // اعتماد طلبية
  GoTo_SpareParts_Homepage: 7, //الانتقال الى الصفحة الرئيسية لقطع الغيار
  Receiving_Orders_WithDriver: 8, // استلام طلبية مرسلة مع سائق
};

export default PERMISSIONS;